import React, { useMemo } from "react";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Label,
} from "reactstrap";
import Select from "react-select";

const CrmFilter = ({
  show,
  onCloseClick,
  leadFilters = [],
  selectedCvid,
  onCvidChange,
  onApplyFilter,
}) => {
  const leadFilterOptions = useMemo(() => {
    if (!Array.isArray(leadFilters)) {
      return [];
    }

    const uniqueFilters = new Map();

    leadFilters
      .filter((filter) => filter && filter.cvid)
      .forEach((filter) => {
        const cvid = Number(filter.cvid);

        if (!uniqueFilters.has(cvid)) {
          uniqueFilters.set(cvid, {
            value: cvid,
            label:
              filter.viewname ||
              filter.name ||
              `Vtiger Filter ${cvid}`,
          });
        }
      });

    return Array.from(uniqueFilters.values());
  }, [leadFilters]);

  const selectedFilter =
    leadFilterOptions.find(
      (option) =>
        Number(option.value) === Number(selectedCvid)
    ) || null;

  const handleFilterChange = (selectedOption) => {
    const cvid = selectedOption
      ? Number(selectedOption.value)
      : null;

    // Update selected CVID
    onCvidChange(cvid);

    // Apply immediately
    if (cvid) {
      onApplyFilter(cvid);
    }
  };

  return (
    <Offcanvas
      direction="end"
      isOpen={show}
      toggle={onCloseClick}
    >
      <OffcanvasHeader
        className="bg-light"
        toggle={onCloseClick}
      >
        Leads Filters
      </OffcanvasHeader>

      <OffcanvasBody>
        <div className="mb-4">
          <Label
            htmlFor="lead-filter-select"
            className="form-label text-muted text-uppercase fw-semibold mb-3"
          >
            Vtiger Filter
          </Label>

          <Select
            id="lead-filter-select"
            value={selectedFilter}
            onChange={handleFilterChange}
            options={leadFilterOptions}
            placeholder="Select Vtiger Filter..."
            isClearable
            isSearchable
            noOptionsMessage={() =>
              "No Vtiger filters found"
            }
          />
        </div>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default CrmFilter;